/**
 * API接口配置
 * 本文件聚合所有API接口配置，提供统一的导出入口
 */

// 导出类型定义
export type { ApiParameter, ResponseField, ApiEndpoint } from './types';

// 导出常量
export { API_CATEGORIES, API_CATEGORY_GROUPS, CATEGORY_GROUP_MAPPING } from './constants';

// 导出工具函数
export { getApisByCategory, getApiById, getAllCategories, getCategoryGroups } from './utils';

// 导入所有接口配置
import { adminEndpoints } from './endpoints/admin';
import { roleEndpoints } from './endpoints/role';
import { permissionEndpoints } from './endpoints/permission';
import { operationEndpoints } from './endpoints/operation';
import { serviceEndpoints } from './endpoints/service';
import { tokenEndpoints } from './endpoints/token';
import { authEndpoints } from './endpoints/auth';
import { configEndpoints } from './endpoints/config';
import { microserviceEndpoints } from './endpoints/microservice';

// 聚合所有接口配置
export const API_ENDPOINTS = [
  ...adminEndpoints,
  ...roleEndpoints,
  ...permissionEndpoints,
  ...operationEndpoints,
  ...serviceEndpoints,
  ...tokenEndpoints,
  ...authEndpoints,
  ...configEndpoints,
  ...microserviceEndpoints,
];

